/* @flow */
import React from 'react';
import TableRowUserName from 'payments/components/TableRowUserName.jsx';
import TransactionAmount from 'payments/components/TransactionAmount.jsx';
import Refund from 'payments/components/Refund.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Transaction from 'entities/Transaction';
import Time from 'components/Time.jsx';
import Button from 'components/Button.jsx';

import 'payments/components/styles/ActivityTable.scss';

type Props = {
  transaction: Transaction,
};

function TransactionsTableRow(props: Props) {
  const { transaction } = props;

  const sent = transaction.isRefundSent();
  const user = sent ? transaction.getPaidTo() : transaction.getPayer();

  return (
    <tr className="ActivityTable-row">
      <td>
        <TableRowUserName user={user} />
      </td>
      <td className="ActivityTable-row-note">
        {transaction.getPaymentMadeFor()}
      </td>
      <td>
        <Time
          date={transaction.getCreatedAt()}
          day="numeric"
          month="short"
        />
      </td>
      <td>
        <div className="ActivityTable-row-amount">
          <div>
            <TransactionAmount transaction={transaction} />
          </div>
          <div>
            {transaction.isRefundable() &&
              <Refund transaction={transaction}>
                {(refund, proccessing) => (
                  proccessing ?
                    <LoadingIndicator size="xsmall" color="lava" /> :
                    <Button
                      color="lava"
                      size="xsmall"
                      level="text"
                      onClick={refund}
                      disabled={proccessing}>
                      Refund
                    </Button>
                )}
              </Refund>
            }
          </div>
        </div>
      </td>
    </tr>
  );
}

export default TransactionsTableRow;



// WEBPACK FOOTER //
// ./src/payments/components/TransactionsTableRow.jsx